export const CUSTOMER_TYPE_FILTER_OPTIONS = [
    { value: "", label: "Tous" },
    { value: "INDIVIDUAL", label: "Particulier" },
    { value: "CORPORATION", label: "Entreprise" }
];

export const EMPTY_CUSTOMER_LIST_FILTERS = {
    search: "",
    accountStatus: "",
    customerType: ""
};
